import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomer,
  BackendCustomerHistogramGeneratedWordsArgs,
  BackendQueryCustomerArgs,
} from 'src/types/backend';

const QUERY = gql`
  query CustomerGeneratedWords($id: ID!, $startDate: ISO8601Date!, $endDate: ISO8601Date!) {
    customer(id: $id) {
      id
      histogram {
        generatedWords(startDate: $startDate, endDate: $endDate) {
          date
          value
        }
      }
    }
  }
`;

type Variables = {
  customerId: BackendQueryCustomerArgs['id'];
} & BackendCustomerHistogramGeneratedWordsArgs;
type Result = Pick<BackendCustomer, 'histogram'>;

export const queryGeneratedWords = async ({ customerId, startDate, endDate }: Variables) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables: { id: customerId, startDate, endDate },
  });
  return getSingleProp<Result>(result.data)?.histogram?.generatedWords;
};
